@if (timeoutLanguages()) {
  <app-timeout></app-timeout>
} @else if (loadingLanguages()) {
  <div style="height: 200px" class="flex justify-content-center align-items-center">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
} @else if (languages()) {
  <div class="list-compact-rows modal-compact-rows">
    <span class="listTitle"> {{ "fault_allocation.fault_lists.language_management.languages" | translate }}</span>
    <div class="listItems">
      @for (lang of languages()!; track $index) {
        <div class="listRow">
          <span> {{ lang.languageName }}</span>
          <div class="actionButtonGroup">
            <app-svg-icon
              (click)="editLanguage(lang)"
              iconName="edit"
              iconColor="primary"
              iconSize="xs"
              class="pointer"
            ></app-svg-icon>
            <app-svg-icon
              (click)="deleteLanguage(lang.languageCode)"
              iconName="trash"
              iconColor="primary"
              iconSize="xs"
              class="pointer"
            ></app-svg-icon>
          </div>
        </div>
      }
    </div>
    <div class="flex">
      <app-button buttonText="fault_allocation.fault_lists.language_management.add_language" (click)="addLanguage()">
      </app-button>
    </div>
  </div>
}
